import { useMutation, useQueryClient } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { DEFAULT_DATE_FORMAT, RAW_DATE_FORMAT } from '@/common/constants';
import { API_URL } from '@/dtos';

import { UpdateAuthorizedUserParams } from '../authorizedUsers.types';

const putAuthorizedUser = (params: UpdateAuthorizedUserParams, id: string) =>
  api.put(API_URL.AUTHORIZED_USERS_BY_ID(id), {
    first_name: params.firstName,
    last_name: params.lastName,
    relationship_type: params.relationshipType,
    birth_on: dayjs(params.birthOn, DEFAULT_DATE_FORMAT).format(RAW_DATE_FORMAT),
  });

const useUpdateAuthorizedUserQuery = (id?: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation(
    (params: UpdateAuthorizedUserParams) => putAuthorizedUser(params, id ?? ''),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [API_URL.EMPLOYEES_AUTHORIZED_USERS_BY_EMPLOYEE_ID('')],
        });
        if (onSuccess) onSuccess();
      },
    }
  );

  return {
    updateAuthorizedUser: mutateAsync,
    isPending,
  };
};

export default useUpdateAuthorizedUserQuery;
